import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  title: {
    fontSize: 40,
    color: theme.colorPalette.green_75
  },
  divider: {
    margin: 0
  },
  formSubtitle: {
    paddingBottom: '0px !important'
  }
});

export default makeStyles(styles);
